import useMediaQuery from "../hooks/useMediaQuery";
import { useFormCtx } from "./../FormContext";
import HiddenBackButton from "./HiddenBackButton";
import Button from "./Button";
import * as Const from "./../_Const";

function Navbar() {
  const lowerThan300 = useMediaQuery("(max-width: 300px)");
  const {
    welcomePageState,
    navigateHome,
    isDebugMode,
    handleDebug,
    getPageData,
    selectedPageIndex,
    showBackButton,
    navigateBackButtons,
    isDebugModeBackBtnClickable,
    navigateToServicePage,
  } = useFormCtx();
  let titleText = welcomePageState?.mobileAppTitle;
  let subTitleText = welcomePageState?.mobileAppSubTitle;
  const titleLength = titleText?.length;
  const showNavigationBackButton = showBackButton();

  let title, subTitle;
  //default subtitle
  if ((subTitleText?.length ?? 0) === 0) {
    subTitleText = "Vítejte v čekárně";
  }

  //jsouli dlouhe nazvy cekarny 20+ tak prohodit titlexsubTitle rotoze subTitle ma mensi pismo
  const limit = Const.isTerminal() ? 50 : 20;
  if (titleLength > limit) {
    title = subTitleText;
    subTitle = titleText;
  } else {
    title = titleText;
    subTitle = subTitleText;
  }

  //jen terminal a ne prvni stranka
  if (Const.isTerminal() && selectedPageIndex != Const.HOME_INDEX) {
    const page = getPageData(selectedPageIndex);
    if (page) {
      title = page.title;
      subTitle = page.subtitle;
    } else {
      title = titleText;
      subTitle = subTitleText;
    }
  }

  function handleHomeClick() {
    navigateHome();
    window.location.reload();
  }

  function getFontSize() {
    //jeli prehozen title do subtitle 20+ a titleLength je 40+ zmensi pismo
    let font = titleLength >= 40 ? "text-base" : "text-xl";
    if (lowerThan300) {
      font = "text-base";
    } else {
      font = "text-xl";
    }
    return font;
  }

  function getFontSizeTitle() {
    let font;
    if (lowerThan300) {
      font = "text-2xl";
    } else {
      font = "text-3xl";
    }
    return font;
  }
  return (
    <nav className="h-24 bg-accent-dark place-content-center text-center drop-shadow-lg">
      {Const.isTerminal() && (
        <>
          <div className="absolute left-4 top-3">
            {showNavigationBackButton && <HiddenBackButton onClick={navigateBackButtons} visible={true} />}
            {!showNavigationBackButton && (
              <HiddenBackButton onClick={handleHomeClick} visible={isDebugMode} isClickable={isDebugModeBackBtnClickable} setVisible={handleDebug} />
            )}
          </div>

          {isDebugMode && (
            <div className="absolute right-4 top-2">
              <Button type="navbar" title="Log aplikace" showIcon={false} onClick={() => navigateToServicePage(Const.PAGE_ERROR_LOG)} className="h-20" />
            </div>
          )}
        </>
      )}

      <h1 className={`font-bold text-white ${getFontSizeTitle()}`}>{title}</h1>
      <p className={`text-white font-light mt-1 ${getFontSize()}`}>{subTitle}</p>
    </nav>
  );
}

export default Navbar;
